import FormatQuoteIcon from '@mui/icons-material/FormatQuote';
import { Typography } from '@mui/material';
import 'bootstrap/dist/css/bootstrap.css';
import Carousel from 'react-bootstrap/Carousel';
import { useMasseuseFeedbacks } from '../hooks/useMasseuseFeedbacks';

function FeedbackSlider({ masseuseId }) {
  const { data: feedbacks } = useMasseuseFeedbacks(masseuseId);

  if (feedbacks && feedbacks.length > 0) {
    return (
      <>
        <Carousel variant="dark" interval={null}>
          {feedbacks.map((feedback) => (
            <Carousel.Item
              key={feedback.id}
              style={{
                padding: '20px 40px 30px 40px',
                border: '1px solid grey',
                borderRadius: '5px',
                textAlign: 'justify',
                borderColor: 'rgba(0, 0, 0, 0.125)',
              }}
              className="text-container"
            >
              <h4 style={{ fontWeight: 500, fontSize: '1rem' }}>
                <FormatQuoteIcon
                  style={{ transform: 'scaleX(-1)', color: '#c3892b' }}
                />
                &nbsp;
                {feedback.content}&nbsp;
                <FormatQuoteIcon style={{ color: '#c3892b' }} />
              </h4>
            </Carousel.Item>
          ))}
        </Carousel>{' '}
        <Typography
          variant="caption"
          display="block"
          gutterBottom
          sx={{
            textAlign: 'center',
            marginTop: '5px',
            color: '#c3892b',
            fontWeight: '600',
          }}
        >
          These comments are left by real customers at the reception desk upon
          checkout.
        </Typography>
      </>
    );
  } else
    return (
      <h4 className="masseuse-details">
        <span className="masseuse-details-span">Feedback Not Available</span>
      </h4>
    );
}

export default FeedbackSlider;
